
    import KLTriangles from './KLTriangles.svelte'

    Array.from(document.getElementsByTagName('KLTriangles')).forEach(node => {
        let props = {
            topElt: node.getAttribute('topElt') || '',
            botElt: node.getAttribute('botElt') || '',
            topLatex: node.getAttribute('topLatex') || '',
            botLatex: node.getAttribute('botLatex') || '',
            tilted: node.getAttribute('tilted') && true || false,
        }
        new KLTriangles({target: node.parentElement, anchor: node, props})
        node.remove()
    })
